import staticQueryData from "../../../public/static/d/3228143367.json";
import { StaticQuery } from 'gatsby';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SiteMetadata from '../SiteMetadata';
import Header from '../Header/index'; // import '../assets/stylesheets/print.scss';

import '../../assets/stylesheets/screen.scss';

function TemplateWrapper(_ref) {
  var children = _ref.children;
  return React.createElement(StaticQuery, {
    query: "3228143367",
    render: function render(data) {
      return React.createElement(Fragment, null, React.createElement(SiteMetadata, {
        siteMetadata: data.site.siteMetadata
      }), React.createElement(Header, null), children);
    },
    data: staticQueryData
  });
}

TemplateWrapper.propTypes = {
  children: PropTypes.any,
  data: PropTypes.any
};
export default TemplateWrapper;